module.exports = "/images/icon-logo-square.svg?3e0c1a53ed92a2760074840a5520ac41";